import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type StoreService from 'ember-data/store';

type SuccessRouteParams = {
  form_id: string;
  pastPeriodIds?: string;
};

export default class AuthenticatedPslfFormSuccessRoute extends Route {
  @service declare store: StoreService;

  queryParams = {
    pastPeriodIds: {
      refreshModel: true,
    },
  };

  async model(params: SuccessRouteParams) {
    const primaryForm = await this.store.findRecord('pslf-form', params.form_id, {
      include: 'attachments',
    });

    const pastPeriodIds = params.pastPeriodIds
      ? params.pastPeriodIds
          .split(',')
          .map((id) => id.trim())
          .filter((id) => id.length > 0)
      : [];

    const pastPeriodForms = await Promise.all(
      pastPeriodIds.map((id) => this.store.findRecord('pslf-form', id, { include: 'attachments' }))
    );

    return {
      primaryForm,
      pastPeriodForms,
      allForms: [primaryForm, ...pastPeriodForms],
    };
  }
}
